import {HEADER_BORDER_BOTTOM, OVERLAY_BORDER} from '../../constants/borderStyles';

export type DragOverlayColumnProps = {
  headerName: string;
  width: number;
};

/**
 * Lightweight header chip shown inside the dnd-kit DragOverlay while the user
 * drags a column or a column group header.  Earlier revisions rendered the
 * full column (header + every visible body cell) for a richer preview, but on
 * grids with N rows × heavy cell renderers (thumbnails, tooltips) that
 * produced an N-fold render cost on every drag-over event and made D&D
 * noticeably slower than AG Grid.  The header-only chip matches the legacy
 * AG Grid behaviour at a fraction of the cost.
 */
export function DragOverlayColumn(props: DragOverlayColumnProps) {
  return (
    <div
      className="bg-white shadow-lg rounded overflow-hidden pointer-events-none"
      style={{width: props.width, maxWidth: props.width, ...OVERLAY_BORDER}}
    >
      <div
        className="px-2 py-2 text-xs font-semibold text-gray-600 bg-gray-50 h-9 flex items-center truncate select-none"
        style={HEADER_BORDER_BOTTOM}
      >
        {props.headerName}
      </div>
    </div>
  );
}
